// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.4.1-2bW5h7N5TLEKpP3hb61d/mode=imports,min/optimized/keen-slider.js' // https://keen-slider.io/docs

class ProductCarousel extends window.BAO.CarouselElement {
  connectedCallback () {
    super.connectedCallback()
    this.carousel = this.initialiseCarousel()
  }

  setupListeners () {
    this.addEventListener('klevuProductsLoaded', this.reinitCarousel.bind(this))
  }

  reinitCarousel () {
    if (this.carousel) {
      this.carousel.destroy()
      this.carousel = this.initialiseCarousel()
    }

    super.reinitialise()
  }

  initialiseCarousel () {
    if (!this.els?.slides?.exists || !this.els?.slide?.exists) return
    return new KeenSlider(this.els.slides.element, {
      selector: this.els.slide.selector,
      drag: true,
      loop: false,
      mode: 'snap',
      rubberband: false,
      slides: {
        origin: 'auto',
        perView: 2,
        spacing: 2,
      },
      breakpoints: {
        '(min-width: 768px)': {
          slides: {
            perView: 3,
            spacing: 15,
          },
        },
        '(min-width: 1201px)': {
          slides: {
            perView: 4,
            spacing: 15,
          },
        },
      },
    })
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel)
}
